"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestProduct = void 0;
var RequestProduct;
(function (RequestProduct) {
    RequestProduct["Studio"] = "studio";
    RequestProduct["Question"] = "question";
})(RequestProduct || (exports.RequestProduct = RequestProduct = {}));
